import {Barcode} from "@variocube/app-api";
import {classNames, typography, View} from "@variocube/cube-ui";
import * as React from "react";
import {Fragment, useEffect, useState} from "react";
import {style, stylesheet} from "typestyle";
import {Controller} from "../controller/Controller";

interface BarcodeReaderViewProps {
    controller: Controller;
}

export function BarcodeReaderView({controller}: BarcodeReaderViewProps) {
    const [code, setCode] = useState<Barcode>();

    useEffect(() => {
        controller.barcodeReader.addBarcodeListener(setCode);
        return () => controller.barcodeReader.removeBarcodeListener(setCode);
    }, [controller]);

    const keys = code?.code
        ? { raw: atob(code?.code), base64: code?.code }
        : undefined;

    return (
        <View className={style({ padding: "0.75em 1.5em" })}>
            <div>Last scanned barcode:</div>
            <div className={styles.keys}>
                {keys && Object.entries(keys).map(([k, v]) => (
                    <Fragment>
                        <div>{k.toUpperCase()}</div>
                        <div className={classNames(typography.monospace, styles.card)}>
                            {v}
                        </div>
                    </Fragment>
                ))}
                {!keys && (
                    <div className={classNames(typography.monospace, styles.card)}>
                        No code scanned.
                    </div>
                )}
            </div>
        </View>
    )
}

const styles = stylesheet({
    card: {
        backgroundColor: "#f0f0f0",
        padding: "0.75em 1.5em",
        borderRadius: "0.25em",
        margin: "0.75em 0"
    },
    keys: {
        marginTop: '0.75rem'
    }
});

